import { render } from "./C_Reg_Item.vue?vue&type=template&id=d0020c3e&scoped=true"
import script from "./C_Reg_Item.vue?vue&type=script&lang=js"
export * from "./C_Reg_Item.vue?vue&type=script&lang=js"

import "./C_Reg_Item.vue?vue&type=style&index=0&id=d0020c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0020c3e"]])

export default __exports__